import { render } from "./PrivacyPolicyText.vue?vue&type=template&id=8cee035e&scoped=true&ts=true"
import script from "./PrivacyPolicyText.vue?vue&type=script&lang=ts"
export * from "./PrivacyPolicyText.vue?vue&type=script&lang=ts"

import "./PrivacyPolicyText.vue?vue&type=style&index=0&id=8cee035e&scoped=true&lang=scss"

import exportComponent from "/opt/source/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8cee035e"]])

export default __exports__